import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";
import AdminTachService from "../../../../service/Docente/AdminTachService";
import TableSelectData from "./BodySelectData/TableSelectData";
import GenericUtils from "../../../../utils/GenericUtils";
import FilterSelectData from "./BodySelectData/FilterSelectData";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";
import {
    IFilter,
    IFilterType,
    IList,
} from "../../../../context/interfaces/IFilterDataContext";
import { WordChoosen } from "../../../../context/interfaces/IAdministratorTachContext";

interface IBodySelectData {
    filter: IFilter;
    handleSetFilter: (arg0: IFilter) => void;
}

const BodySelectData: React.FC<IBodySelectData> = ({
    filter,
    handleSetFilter,
}) => {
    const [searchList, setSearchList] = useState<IList[]>([]);

    const { instance } = useMsal();

    const { modalFilterOptions } = useFilterData();

    const referenceKey = modalFilterOptions.key;
    const referenceList = (filter[referenceKey] as IFilterType).list;

    const getKeyName = (key: WordChoosen) => {
        const names = {
            campus: "Campus",
            course: "Curso",
            school: "Escola",
            modality: "Modalidade",
            professor: "Professor",
        };
        return names[key];
    };

    const keyName = getKeyName(referenceKey as WordChoosen);

    const fetchUrlData = async (): Promise<void> => {
        let response;
        let path;
        let param: string;
        let hasDescription: boolean;
        let descriptionParam: string;

        const campusList = GenericUtils.formatFilterToList(
            "campus",
            "name",
            filter
        );
        const schoolList = GenericUtils.formatFilterToList(
            "school",
            "name",
            filter
        );
        const modalityList = GenericUtils.formatFilterToList(
            "modality",
            "id",
            filter
        );
        const courseList = GenericUtils.formatFilterToList(
            "course",
            "id",
            filter
        );

        if (referenceKey === "school") {
            response = await AdminTachService.getSchoolsRoute(
                instance,
                campusList
            );
            path = response.data.itens;
            param = "name";
        }
        if (referenceKey === "modality") {
            response = await AdminTachService.getModalityRoute(
                instance,
                campusList,
                schoolList
            );
            path = response.data.itens;
            param = "descricao";
        }
        if (referenceKey === "campus") {
            response = await AdminTachService.getResultCampus(instance);
            path = response.data.campi;
            param = "id";
        }
        if (referenceKey === "course") {
            response = await AdminTachService.getCoursesRoute(
                instance,
                campusList,
                schoolList,
                modalityList
            );
            path = response.data.itens;
            param = "descricao";
        }
        if (referenceKey === "professor") {
            response = await AdminTachService.getProfessorRoute(
                instance,
                courseList
            );
            path = response.data.itens;
            param = "nome";
            hasDescription = true;
            descriptionParam = "matriculaAdp";
        }

        if (GenericUtils.isSuccessStatus(response) && path?.length) {
            const uniqueNames = new Set<string>();
            const cleanData = path.reduce((acc: IList[], item: any) => {
                const name = item[param];
                if (!uniqueNames.has(name)) {
                    uniqueNames.add(name);
                    // eslint-disable-next-line no-param-reassign
                    acc = [
                        ...acc,
                        {
                            id: item.id,
                            name,
                            description: hasDescription
                                ? item[descriptionParam]
                                : "",
                        },
                    ];
                }
                return acc;
            }, []);

            const newFilter: IFilter = {
                ...filter,
                [referenceKey]: {
                    ...(filter[referenceKey] as IFilterType),
                    list: cleanData,
                },
            };
            handleSetFilter(newFilter);
        }
    };

    useEffect(() => {
        fetchUrlData();
    }, []);

    useEffect(() => {
        setSearchList(referenceList);
    }, [referenceList]);

    return (
        <>
            <FilterSelectData
                keyName={keyName}
                referenceList={referenceList}
                setSearchList={setSearchList}
            />
            <TableSelectData keyName={keyName} list={searchList} />
        </>
    );
};

export default BodySelectData;
